import _ from 'underscore';
import Util from 'views/utils/LeafletMap/utils/Util';
import MapProvider from 'views/utils/LeafletMap/MapProviders/MapProvider';
import BaiduDirectionService from 'views/utils/LeafletMap/MapServices/BaiduDirectionService';
import BaiduLocationService from 'views/utils/LeafletMap/MapServices/BaiduLocationService';

var LayerTypeMapping = {
    ROAD: 'ROAD.Map',
    SATELLITE: 'SATELLITE.Map'
};

var BaiduProvider = function(args) {
    MapProvider.apply(this, args);

    this.directionService = new BaiduDirectionService({
        transitMode: args.transitMode
    });

    this.locationService = new BaiduLocationService({});

    this.name = Util.MapProviders.BAIDU;
};

BaiduProvider.prototype = Object.create(MapProvider.prototype);
BaiduProvider.prototype.constructor = BaiduProvider;

//SHARED METHODS
BaiduProvider.prototype.getTileLayer = function getTileLayer(layerType) {
    if (layerType && LayerTypeMapping[layerType]) {
        layerType = LayerTypeMapping[layerType];
    } else {
        layerType = LayerTypeMapping.ROAD;
    }
    return layerType;
};

export default BaiduProvider;
